module.exports = __webpack_public_path__ + "static/media/accessory11.5268140b.webp";